//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { EXIT_CONFIRMATION_MODAL_ACTIONS } from '@catalog-ingestion/constants/exitConfirmationModalConstants';
import { createAction } from '@utils/actions';

const openExitConfirmationModal = () => {
  return createAction({
    type: EXIT_CONFIRMATION_MODAL_ACTIONS.OPEN_MODAL,
  });
};

const closeExitConfirmationModal = () => {
  return createAction({
    type: EXIT_CONFIRMATION_MODAL_ACTIONS.CLOSE_MODAL,
  });
};

export type ExitConfirmationModalAction = ReturnType<
  typeof openExitConfirmationModal |
  typeof closeExitConfirmationModal
>;

export const ExitConfirmationModalActions = {
  openExitConfirmationModal,
  closeExitConfirmationModal,
};
